export interface Stadium {
  /** Stable id, also used as the image filename: public/images/stadiums/<id>.jpg */
  id: string;
  name: string;
  city: string;
  country: "USA" | "Mexico" | "Canada";
  /** Approximate tournament capacity. */
  capacity: number;
  /** Optional highlight, e.g. "Final" or "Opening match". */
  notable?: string;
}

// The 16 host venues of the 2026 FIFA World Cup (USA · Canada · Mexico).
// Capacities are approximate. Photos are expected at
// public/images/stadiums/<id>.jpg (a placeholder shows until added).
export const STADIUMS: Stadium[] = [
  { id: "metlife", name: "MetLife Stadium", city: "East Rutherford (New York / New Jersey)", country: "USA", capacity: 82500, notable: "Final" },
  { id: "att", name: "AT&T Stadium", city: "Arlington (Dallas)", country: "USA", capacity: 80000 },
  { id: "mercedes-benz", name: "Mercedes-Benz Stadium", city: "Atlanta", country: "USA", capacity: 71000 },
  { id: "nrg", name: "NRG Stadium", city: "Houston", country: "USA", capacity: 72000 },
  { id: "arrowhead", name: "Arrowhead Stadium", city: "Kansas City", country: "USA", capacity: 76000 },
  { id: "hard-rock", name: "Hard Rock Stadium", city: "Miami Gardens", country: "USA", capacity: 65000 },
  { id: "gillette", name: "Gillette Stadium", city: "Foxborough (Boston)", country: "USA", capacity: 65000 },
  { id: "lincoln-financial", name: "Lincoln Financial Field", city: "Philadelphia", country: "USA", capacity: 69000 },
  { id: "levis", name: "Levi's Stadium", city: "Santa Clara (San Francisco Bay Area)", country: "USA", capacity: 68500 },
  { id: "lumen", name: "Lumen Field", city: "Seattle", country: "USA", capacity: 69000 },
  { id: "sofi", name: "SoFi Stadium", city: "Inglewood (Los Angeles)", country: "USA", capacity: 70000 },
  { id: "azteca", name: "Estadio Azteca", city: "Mexico City", country: "Mexico", capacity: 83000, notable: "Opening match" },
  { id: "akron", name: "Estadio Akron", city: "Guadalajara", country: "Mexico", capacity: 48000 },
  { id: "bbva", name: "Estadio BBVA", city: "Monterrey", country: "Mexico", capacity: 53500 },
  { id: "bmo", name: "BMO Field", city: "Toronto", country: "Canada", capacity: 45000 },
  { id: "bc-place", name: "BC Place", city: "Vancouver", country: "Canada", capacity: 54500 },
];
